var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"svgEl",domProps:{"innerHTML":_vm._s(_vm.svg)}})}
var staticRenderFns = []

export { render, staticRenderFns }